import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import IconBase from '../IconBase';
var Svg24X24BlockOutline = function Svg24X24BlockOutline(props) {
  return /*#__PURE__*/React.createElement(IconBase, _extends({
    viewBox: "0 0 24 24"
  }, props, {
    width: "24",
    height: "24"
  }), /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M18.33 4.257c-3.93-3.219-9.735-2.995-13.402.672s-3.89 9.472-.672 13.4l-.035.035.686.686.021.021.02.02.687.687.035-.035c3.928 3.219 9.733 2.995 13.4-.672s3.89-9.472.672-13.4l.035-.035-1.414-1.414-.035.035ZM16.905 5.68A8.001 8.001 0 0 0 5.68 16.906zM7.094 18.32A8.001 8.001 0 0 0 18.32 7.094z",
    clipRule: "evenodd"
  })));
};
export default Svg24X24BlockOutline;